export default class Header {
  constructor(lenis) {
    this.lenis = lenis;
    document.addEventListener('DOMContentLoaded', () => {
      this.init();
    });
  }

  init() {
    const header = document.querySelector('.l-header');
    const headerHeight = header.offsetHeight ?? 0;


    //Lenis のスクロールイベントに反応
    if (!this.lenis) return;

    this.lenis.on('scroll', ({ scroll }) => {

      const scrollY = scroll;

       // モーダルが開いているときはクラス操作をスキップ
      if (document.body.classList.contains('is-modal-open')) return;

      if (scrollY > headerHeight) {
        header.classList.add('is-active');
      } else {
        header.classList.remove('is-active');
      }
    });


  }



}
